/* eslint-disable import/prefer-default-export */
import Vue from 'vue'
import url from '@/services/ApiServices/apiUrls'
import { store } from '../../store/store'
import * as productApi from './productApi'

export const brandApis = new Vue({
	methods: {
		brandData (brandId, currentCategoryId) {
			const getUrl = url.brandDataUrl + brandId
			return new Promise((resolve, reject) => {
				this.$http.get(getUrl)
					.then((res) => {
						const brandProductsData = []
						if (res.data && res.data.brand_products) {
							if (brandId !== 'unbranded') {
								res.data.brand_products[currentCategoryId].forEach((product) => {
									productApi.assignVendorInventoryAndPromotionalPrices(product)
									brandProductsData.push(product)
								})
								delete res.data.brand_products[currentCategoryId]
							}
							const productCategories = Object.keys(res.data.brand_products)
							productCategories.forEach((category) => {
								res.data.brand_products[category].forEach((product) => {
									productApi.assignVendorInventoryAndPromotionalPrices(product)
									brandProductsData.push(product)
								})
							})
							store.dispatch('filters/setFilter', [])
							store.dispatch('filters/updateFilters', [])
							store.dispatch('productselected/setSelectedProductData', brandProductsData)
						}
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		}
	}
})
